import { ProgressBar, Stack, Text } from 'shell/components';

const SubmissionProcessingProgress = ({ completed, total, label, children }) => (
    <Stack aria-live={'polite'}>
        <Text color={'light'}>{label}</Text>
        <Stack alignItems={'center'} direction={'row'} spacing={4}>
            <ProgressBar
                aria-label={'submission process progress'}
                simulateProgress={{ duration: 30, maxValue: 90 }}
                value={total ? Number(((completed / total) * 100).toFixed(0)) : 0}
            />
            {children}
        </Stack>
    </Stack>
);

export default SubmissionProcessingProgress;
